(() => {
  'use strict';

  const managedNames = ['Original price', 'You save'];

  const formatMoney = (cents) => {
    const shopifyCurrency = window.Shopify && window.Shopify.currency;
    const currency = typeof shopifyCurrency === 'object'
      ? shopifyCurrency.active
      : shopifyCurrency;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents) / 100);
    } catch (error) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  };

  const removeManagedProperties = (form) => {
    form.querySelectorAll('[data-sz-checkout-price]').forEach((input) => input.remove());
  };

  const setProperty = (form, name, value) => {
    let input = form.querySelector('input[data-sz-checkout-price][data-property-name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.dataset.szCheckoutPrice = '';
      input.dataset.propertyName = name;
      form.appendChild(input);
    }

    input.value = value;
  };

  const syncCheckoutPrices = (form) => {
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;

    const component = form.closest('[data-js-product-component]');
    const variantData = component && component.querySelector('[data-js-variant-data]');

    if (!variantData) {
      removeManagedProperties(form);
      return;
    }

    try {
      const variant = JSON.parse(variantData.textContent);
      const price = Number(variant.price);
      const compareAtPrice = Number(variant.compare_at_price);

      removeManagedProperties(form);

      if (!Number.isFinite(price) || !Number.isFinite(compareAtPrice) || compareAtPrice <= price) return;

      setProperty(form, managedNames[0], formatMoney(compareAtPrice));
      setProperty(form, managedNames[1], formatMoney(compareAtPrice - price));
    } catch (error) {
      removeManagedProperties(form);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-js-product-add-to-cart]');
    if (button) syncCheckoutPrices(button.form || button.closest('form'));
  }, true);

  document.addEventListener('submit', (event) => {
    syncCheckoutPrices(event.target);
  }, true);
})();
